import styled from 'styled-components';

const Panel = styled.div.attrs({
  className: `
    py-6
    px-4

    rounded-md
    shadow
    bg-white

    dark:bg-gray-800
    dark:border
    dark:border-gray-700
  `,
})``;

export default Panel;
